import { Image, StyleSheet } from 'react-native'
import { ThemedView, ThemedText, Theme } from '@app/theme'
import { useTheme } from '@shopify/restyle'
import Button from '@app/sharedComponents/Button/Button'
import { ThemedTouchableOpacity } from '@app/theme/Components'
import CrossIcon from '../../../../assets/Icons/CrossIcon'
import Svg from '@app/sharedComponents/SvgImage/Svg'


const TataSignErrorModal = ({ onRetry, onContact }: { onRetry: () => void, onContact: () => void }) => {

  const { colors } = useTheme<Theme>();


  return (
    <ThemedView padding='lg' justifyContent='center' alignItems='center'>
      <ThemedTouchableOpacity hitSlop={{ top: 16, right: 16, bottom: 16, left: 16 }} position='absolute' top={16} right={16} onPress={onRetry}>
        <CrossIcon />
      </ThemedTouchableOpacity>
      <Svg
        url='https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StatusFailed_1.svg'
        height={48}
        width={48}
      />
      <ThemedText mt='lg' variant='h5s'>Agreement signing failed!</ThemedText>
      <ThemedText textAlign='center' mt='sm' variant='b3r' color='text-secondary'>We encountered an error while signing the loan agreement. Please retry the process.</ThemedText>
      <ThemedView alignSelf='stretch' marginVertical='md'>
        <Button
          label="Try again"
          type="OUTLINED"
          size='MD'
          handlePress={onRetry}
          bg={colors['bg-action-primary']}
          textColor={colors['text-primary']}
        />
      </ThemedView>
      <ThemedText variant='b3r' color='text-primary'>Need help? <ThemedText onPress={onContact} variant='b3s' color='text-action-primary'>Contact us</ThemedText></ThemedText>
    </ThemedView>
  )
}

export default TataSignErrorModal

const styles = StyleSheet.create({})